function validateAWB(awb: string): boolean {

  if (awb.match(/^\d{3}-\d{8}$/)) {
      return true;
  }

  return false;
}

function validateAirwayCode(awbCode: string): RegExpMatchArray | null {
  return awbCode.match(/^\d{3}$/);
}

function validateBillNumber(awbNumber: string): boolean {

  if (!awbNumber.match(/^\d{8}$/)) {
    return false;
  }

  if (parseInt(awbNumber.substr(0, 7)) % 7 == parseInt(awbNumber[7])) {
    return true;
  }

  return false;
}

function validateEmail(email: string): boolean {

  if (email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
    return true;
  }

  return false;
}

function validatePhoneNumber(phoneNumber: string): boolean {

  if (phoneNumber.match(/^\+?[1-9]\d{9,}$/)) {
    return true;
  }

  return false;
}

function validateSetMoneySum(sum: string): boolean {

  if(sum.match(/^(""|0|[1-9]\d*)(''|\.|\.[0-9]{1}|\.[0-9]{2})?$/)) {
    return true;
  }
  return false
}

export default {
  validateAWB,
  validateAirwayCode,
  validateBillNumber,
  validateEmail,
  validatePhoneNumber,
  validateSetMoneySum
}